import { render, staticRenderFns } from "./friendContent.vue?vue&type=template&id=47d983f6"
import script from "./friendContent.vue?vue&type=script&lang=js"
export * from "./friendContent.vue?vue&type=script&lang=js"
import style0 from "./friendContent.vue?vue&type=style&index=0&id=47d983f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports